import { getCurrentUrl, route } from 'preact-router';

function get (url){
  return new Promise((resolve, reject) => {
    var xhr = new XMLHttpRequest();

    xhr.onload = function() {
      if (xhr.status >= 400 && xhr.status < 600) {
        reject(new Error(`Could not get data, ${xhr.status} ${xhr.statusText}`));
      }

      resolve(xhr);
    };

    xhr.onerror = reject;

    xhr.open('get', url, true);
    xhr.send();
  });
}

const JSON_FILENAME = /\.json(?:[\?#].*)?$/;

export function fetch (url){
  return get(url)
  .then(xhr => xhr.responseXML && xhr.responseXML.childNodes || xhr.responseText)
  .then(data => {
    if (JSON_FILENAME.test(url)) {
      try {
        data = JSON.parse(data);
      }

      catch (err) {
        console.warn('Could not parse data as JSON', url);
      }
    }

    return data;
  });
}

const COUNTRY_YEAR_PATHNAME = /^\/([a-z]{3})?\/?(\d{4})?\/?/;

export function currentPath () {
  const path = typeof window === 'undefined' ?
    getCurrentUrl() : window.location.pathname;
  
  return parsePath(path);
}

export function parsePath (path) {
  const [, countryId = null, year = null] = path.match(COUNTRY_YEAR_PATHNAME);

  return { countryId, year: year && Number(year) };
}

export function setRoute (year, countryId, replace) {
  // Auto-replace if no change to country, only a change to year
  if (typeof replace !== 'boolean') {
    const path = currentPath();
    replace = (countryId === path.countryId && year && path.year) || false;
  }

  let url = '';

  if (countryId) {
    url += `/${countryId}`;
  }

  if (year) {
    url += `/${year}`;
  }

  // console.log({year, countryId, url});

  route(url || '/', replace);
}

export function getValueGrouping (value) {
  if (value === 0) {
    return '0';
  }

  if (value === 1) {
    return '1';
  }

  if (value < 4) {
    return '2-3';
  }

  if (value < 21) {
    return '4-20';
  }

  if (value < 51) {
    return '21-50';
  }

  return '51+';
}



// WEBPACK FOOTER //
// ./lib/utils.js